/* ===== from <script id="dba-bakeraid-intro-intro-js"> ===== */

(function(){
  function injectMeetIntro(){
    if (document.querySelector('.dba-bakeraid-intro')) return;
    // Homepage only
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path !== '/') return;
    // Find the hero slideshow section (or any reasonable first-section anchor)
    var hero = document.querySelector('.dba-hero[data-sid]') || document.querySelector('.dba-hero') || document.querySelector('[class*="dba-hero"]');
    if (!hero) return;
    var heroSection = hero.closest('.shopify-section') || hero;
    var section = document.createElement('section');
    section.className = 'dba-bakeraid-intro';
    section.innerHTML =
      '<div class="dba-bakeraid-intro__inner">' +
        '<span class="dba-bakeraid-intro__eyebrow">The SureDough™ system</span>' +
        '<h2 class="dba-bakeraid-intro__h">Meet <em>D’BakerAid™</em></h2>' +
        '<p class="dba-bakeraid-intro__lede">The world’s first science-backed home fermentation and proofing system, engineered to bring lab-level precision to bread, pizza, and dough-based baking.</p>' +
        '<a href="#shopify-section-dba_video_frame" class="dba-bakeraid-intro__cta">See how it works <span class="dba-bakeraid-intro__cta-arrow">→</span></a>' +
      '</div>';
    // Insert right AFTER the hero section
    heroSection.parentNode.insertBefore(section, heroSection.nextSibling);
    // Smooth scroll to video frame when CTA clicked (graceful even if anchor missing)
    section.querySelector('.dba-bakeraid-intro__cta').addEventListener('click', function(e){
      var vf = document.querySelector('[id*="dba_video_frame"], .dba2-section, #shopify-section-dba_video_frame');
      if (vf) { e.preventDefault(); vf.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  }

  function injectPdpMeet(){
    if (document.querySelector('.dba-pdp-meet')) return;
    var path = (window.location.pathname || '/');
    if (!/^\/products\//.test(path)) return;
    // Find the product H1
    var h1 = document.querySelector('.dba-pdp-title, h1.product-title, h1[class*="product__title"], product-title h1, main h1, h1');
    if (!h1) return;
    var titleText = (h1.textContent || '').toLowerCase();
    if (titleText.length < 4) return;
    // Insert OUTSIDE any product-title / h1-wrapper element so we don't inherit its huge serif styling.
    // Walk up from h1 to find the highest wrapper that's still title-only, then insert AFTER that wrapper.
    var insertAfter = h1;
    var parent = h1.parentElement;
    while (parent && parent.tagName !== 'BODY' && parent.children.length === 1 && /title|heading/i.test(parent.tagName + ' ' + (parent.className||''))) {
      insertAfter = parent;
      parent = parent.parentElement;
    }
    var p = document.createElement('p');
    p.className = 'dba-pdp-meet';
    p.textContent = "The world’s first science-backed home fermentation and proofing system — lab-level precision for bread, pizza, and dough-based baking.";
    if (insertAfter.parentNode) insertAfter.parentNode.insertBefore(p, insertAfter.nextSibling);
  }

  function applyMeetIntro(){
    try { injectMeetIntro(); } catch(e){}
    try { injectPdpMeet(); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyMeetIntro, {once:true});
  else applyMeetIntro();
  window.addEventListener('load', applyMeetIntro);
  document.addEventListener('shopify:section:load', applyMeetIntro);
  setTimeout(applyMeetIntro, 800);
  setTimeout(applyMeetIntro, 2400);
})();

;
/* ===== from <script id="dba-v63-ux-js"> ===== */

(function(){
  window.__dbaV63Loaded = true;
  /* (1b) Sticky-header scrolled state — add body class for box-shadow cue */
  function updateScrollState(){
    try {
      if (window.scrollY > 4) document.body.classList.add('dba-scrolled');
      else document.body.classList.remove('dba-scrolled');
    } catch(e){}
  }
  window.addEventListener('scroll', updateScrollState, {passive:true});

  /* (2) ACTIVE-PAGE MENU INDICATOR */
  function markActivePage(){
    try {
      var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
      var scopes = document.querySelectorAll('header, header-component, #header-group');
      if (!scopes.length) return;
      scopes.forEach(function(headerScope){
        headerScope.querySelectorAll('a[href]').forEach(function(a){
          var href = a.getAttribute('href') || '';
          if (!href || href === '#' || /^(javascript|mailto|tel):/i.test(href)) return;
          try {
            var url = new URL(href, window.location.origin);
            if (url.hostname && url.hostname !== window.location.hostname) {
              a.classList.remove('is-current-page'); a.removeAttribute('aria-current'); return;
            }
            var aPath = (url.pathname || '/').replace(/\/$/, '') || '/';
            var match = (aPath === path);
            if (match) { a.classList.add('is-current-page'); a.setAttribute('aria-current', 'page'); }
            else { a.classList.remove('is-current-page'); a.removeAttribute('aria-current'); }
          } catch(e){}
        });
      });
    } catch(e){}
  }

  /* (5) REVIEWS FOOTER LINK → PDP#looxReviews */
  function rewriteReviewsLinks(){
    try {
      var newHref = '/products/dbakeraid-complete-kit#looxReviews';
      document.querySelectorAll('a').forEach(function(a){
        var h = a.getAttribute('href') || '';
        if (/^\/pages\/reviews\/?$/.test(h)) a.setAttribute('href', newHref);
      });
    } catch(e){}
  }

  function applyAll(){ updateScrollState(); markActivePage(); rewriteReviewsLinks(); }

  /* Run on every plausible event */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyAll, {once:true});
  else applyAll();
  window.addEventListener('load', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
  document.addEventListener('page:loaded', applyAll);

  /* Aggressive retry: 500ms × 20 = 10s coverage */
  var retries = 0;
  var retry = setInterval(function(){ applyAll(); if (++retries >= 20) clearInterval(retry); }, 500);

  /* MutationObserver — re-apply whenever the header/footer DOM changes */
  if ('MutationObserver' in window){
    var mo = new MutationObserver(function(mutations){
      var relevant = false;
      for (var i = 0; i < mutations.length; i++){
        var m = mutations[i];
        var t = m.target;
        if (!t) continue;
        if (t.closest && (t.closest('header') || t.closest('header-component') || t.closest('#header-group') || t.closest('footer'))) { relevant = true; break; }
      }
      if (relevant) applyAll();
    });
    // Wait for body to be ready, then observe
    function startObserving(){
      if (!document.body) { setTimeout(startObserving, 50); return; }
      mo.observe(document.body, {childList:true, subtree:true, attributes:false});
    }
    startObserving();
  }
})();

;
/* ===== from <script id="dba-hero-autoplay-fix"> ===== */

/* v50: Patches the hero-slideshow section's pre-existing bug where touchstart calls stop() but nothing
   ever restarts autoplay. Plus: (a) injects bespoke installment line under each slide's CTAs,
   (b) wires real touch-swipe handlers (left/right gestures advance slides),
   (c) lifts the section's own touchstart→stop bug, (d) shims swipe on Shopify product gallery. */
(function(){
  function injectHeroInstallment(slide){
    // v51: REMOVED old under-button line; clean up any lingering nodes from previous versions
    var oldLines = slide.querySelectorAll('.dba-hero__installment');
    oldLines.forEach(function(n){ n.parentNode && n.parentNode.removeChild(n); });

    var primary = slide.querySelector('.dba-hero__cta--primary');
    if (!primary || primary.__dbaInstInside) return;
    primary.__dbaInstInside = true;

    // Wrap the existing button text in a top-line span, then append a smaller installment sub-line
    // (Idempotent: if we already split it, skip)
    if (primary.querySelector('.dba-hero__cta-installment')) return;
    var labelText = (primary.textContent || '').trim();
    primary.innerHTML = '';
    var top = document.createElement('span');
    top.className = 'dba-hero__cta-label';
    top.textContent = labelText;
    primary.appendChild(top);
    var sub = document.createElement('span');
    sub.className = 'dba-hero__cta-installment';
    sub.textContent = 'As low as US$28/mo, rates apply';
    primary.appendChild(sub);
  }

  function init(){
    document.querySelectorAll('.dba-hero[data-sid]').forEach(function(root){
      // Always (re)inject installment lines — sections can re-render via Shopify section load events
      root.querySelectorAll('.dba-hero__slide').forEach(injectHeroInstallment);
      if (root.__dbaHeroFix) return;
      root.__dbaHeroFix = true;
      var bgs = root.querySelectorAll('.dba-hero__bg');
      var slides = root.querySelectorAll('.dba-hero__slide');
      var dots = root.querySelectorAll('.dba-hero__dot');
      var total = bgs.length;
      if (total < 2) return;
      var ms = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6000;
      var fixTimer = null;

      function getCurrent(){
        for (var i=0; i<bgs.length; i++) if (bgs[i].classList.contains('is-active')) return i;
        return 0;
      }
      function go(delta){
        var cur = getCurrent();
        var next = (cur + delta + total) % total;
        [bgs, slides, dots].forEach(function(g){ g.forEach(function(el,i){ el.classList.toggle('is-active', i===next); }); });
        var v = bgs[next].querySelector('video');
        if (v) { try { v.currentTime = 0; v.play().catch(function(){}); } catch(e){} }
      }
      function restart(){
        if (fixTimer) clearInterval(fixTimer);
        fixTimer = setInterval(function(){ go(1); }, ms);
      }
      function stopFix(){ if (fixTimer){ clearInterval(fixTimer); fixTimer = null; } }

      // v50: Real swipe handler — left/right gestures advance slides
      var touchStartX = 0, touchStartY = 0, touchActive = false;
      root.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, {passive:true});
      root.addEventListener('touchend', function(e){
        if (!touchActive) { setTimeout(restart, 1500); return; }
        touchActive = false;
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        if (t) {
          var dx = t.clientX - touchStartX;
          var dy = t.clientY - touchStartY;
          // Horizontal swipe wins if |dx| > |dy| AND |dx| > 40px (avoids fighting vertical scroll)
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            go(dx < 0 ? 1 : -1); // swipe left → next, swipe right → prev
          }
        }
        setTimeout(restart, 1500);
      }, {passive:true});
      root.addEventListener('touchcancel', function(){ touchActive = false; setTimeout(restart, 1500); }, {passive:true});

      // Wire the existing arrow buttons (in case the section's own JS missed them after re-render)
      var prev = root.querySelector('.dba-hero__nav--prev');
      var next = root.querySelector('.dba-hero__nav--next');
      if (prev && !prev.__dbaBound){ prev.__dbaBound = true; prev.addEventListener('click', function(){ go(-1); restart(); }); }
      if (next && !next.__dbaBound){ next.__dbaBound = true; next.addEventListener('click', function(){ go(1); restart(); }); }

      // Pause autoplay when the hero scrolls out of view (perf), restart when it scrolls back in
      if ('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting) restart();
            else stopFix();
          });
        }, {threshold:0.25});
        io.observe(root);
      }

      // Try to ensure the FIRST slide's video actually plays on mobile (some browsers block initial autoplay)
      var firstV = bgs[0] && bgs[0].querySelector('video');
      if (firstV) {
        var tryPlay = function(){ try { firstV.play().catch(function(){}); } catch(e){} };
        tryPlay();
        // Re-try on first user interaction (works around iOS autoplay blocks)
        var oneShot = function(){
          tryPlay();
          document.removeEventListener('touchstart', oneShot);
          document.removeEventListener('click', oneShot);
        };
        document.addEventListener('touchstart', oneShot, {passive:true, once:true});
        document.addEventListener('click', oneShot, {once:true});
      }

      restart();
    });
  }

  // ---------- v50: Product-page gallery swipe shim ----------
  // Most Shopify gallery components have native swipe, but some custom themes block touch events
  // or fail to bind them inside slideshow-component. This adds a fallback handler that drives whichever
  // arrow / native control is exposed by the component.
  function initProductGallerySwipe(){
    var galleries = document.querySelectorAll(
      'product-media-gallery, .product-media-gallery, slideshow-component, .media-gallery, [class*="product-gallery"]'
    );
    galleries.forEach(function(g){
      if (g.__dbaSwipeShim) return;
      g.__dbaSwipeShim = true;
      var sx = 0, sy = 0, active = false;
      g.addEventListener('touchstart', function(e){
        if (!e.touches || !e.touches[0]) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; active = true;
      }, {passive:true});
      g.addEventListener('touchend', function(e){
        if (!active) return; active = false;
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        if (!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) <= 40 || Math.abs(dx) <= Math.abs(dy) * 1.2) return; // not a horizontal swipe
        // Find the gallery's next/prev controls in priority order — v51 adds .slideshow-control--*
        var control = dx < 0
          ? g.querySelector('.slideshow-control--next, button[name="next"], button[aria-label="Next slide"], [aria-label*="next" i], [class*="next-arrow"], [class*="arrow-next"], .swiper-button-next, .splide__arrow--next, [data-direction="next"]')
          : g.querySelector('.slideshow-control--previous, button[name="previous"], button[aria-label="Previous slide"], [aria-label*="prev" i], [class*="prev-arrow"], [class*="arrow-prev"], .swiper-button-prev, .splide__arrow--prev, [data-direction="previous"]');
        if (control) { try { control.click(); } catch(e){} }
      }, {passive:true});
    });
  }

  // ---------- v54: Hero-style arrow enforcer — wins over Horizon's .button-unstyled--transparent ----------
  // External CSS (even with !important) loses to Horizon's cascade layers on slideshow-control buttons.
  // Inline styles set via setProperty('important') win regardless. This sweeps every matching control,
  // applies the hero arrow look, and re-applies after Shopify re-renders the component.
  function enforceArrowStyles(){
    var sels = [
      'slideshow-component .slideshow-control--previous',
      'slideshow-component .slideshow-control--next',
      'media-gallery .slideshow-control--previous',
      'media-gallery .slideshow-control--next',
      'product-media-gallery .slideshow-control--previous',
      'product-media-gallery .slideshow-control--next',
      '.splide__arrow',
      '.swiper-button-prev',
      '.swiper-button-next'
    ];
    var isMobile = window.innerWidth <= 768;
    var size = isMobile ? '36px' : '44px';
    var edge = isMobile ? '8px' : '24px';
    var iconSize = isMobile ? '16px' : '20px';
    document.querySelectorAll(sels.join(',')).forEach(function(btn){
      // v55: Strip Horizon's button utility classes — they're inside cascade layers and
      // beat our !important inline styles. Removing them lets our styles render.
      ['button', 'button-unstyled', 'button-unstyled--transparent'].forEach(function(c){
        if (btn.classList.contains(c)) btn.classList.remove(c);
      });
      btn.style.setProperty('background-color', 'rgba(26,18,0,0.6)', 'important');
      btn.style.setProperty('color', '#F4EFE6', 'important');
      btn.style.setProperty('border', '1px solid rgba(201,168,76,0.4)', 'important');
      btn.style.setProperty('border-radius', '0', 'important');
      btn.style.setProperty('width', size, 'important');
      btn.style.setProperty('height', size, 'important');
      btn.style.setProperty('display', 'flex', 'important');
      btn.style.setProperty('align-items', 'center', 'important');
      btn.style.setProperty('justify-content', 'center', 'important');
      btn.style.setProperty('opacity', '1', 'important');
      btn.style.setProperty('visibility', 'visible', 'important');
      btn.style.setProperty('z-index', '5', 'important');
      btn.style.setProperty('padding', '0', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      var isPrev = /(--previous|--prev|prev)/.test(btn.className);
      if (isPrev) {
        btn.style.setProperty('left', edge, 'important');
        btn.style.setProperty('right', 'auto', 'important');
      } else {
        btn.style.setProperty('right', edge, 'important');
        btn.style.setProperty('left', 'auto', 'important');
      }
      // Force the SVG chevron to be visible and sized correctly
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.setProperty('width', iconSize, 'important');
        svg.style.setProperty('height', iconSize, 'important');
        svg.style.setProperty('stroke', '#F4EFE6', 'important');
        svg.style.setProperty('fill', 'none', 'important');
        svg.style.setProperty('stroke-width', '2', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ init(); initProductGallerySwipe(); enforceArrowStyles(); }, {once:true});
  } else {
    init(); initProductGallerySwipe(); enforceArrowStyles();
  }
  document.addEventListener('shopify:section:load', function(){ init(); initProductGallerySwipe(); enforceArrowStyles(); }, {passive:true});
  // Re-bind + re-style on DOM changes for late-rendered galleries
  setTimeout(function(){ init(); initProductGallerySwipe(); enforceArrowStyles(); }, 800);
  setTimeout(function(){ init(); initProductGallerySwipe(); enforceArrowStyles(); }, 2000);
  setTimeout(function(){ init(); initProductGallerySwipe(); enforceArrowStyles(); }, 5000);

  // MutationObserver: re-enforce styles whenever Shopify re-renders the gallery
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function(){ enforceArrowStyles(); });
    mo.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','style']});
  }
  // Re-apply on resize (in case mobile <-> desktop breakpoint crosses)
  window.addEventListener('resize', function(){ enforceArrowStyles(); }, {passive:true});
})();

;
